export function incidentKeyPointerBase(keyPointer?: unknown): string {
  return String(keyPointer || '').replace(/^incident_/, '');
}

export function isIncidentYesNoKeyPointer(keyPointer?: unknown): boolean {
  const base = incidentKeyPointerBase(keyPointer);
  return base === 'propertyDamage' || base === 'atSea';
}

export function isInjuryTypeKeyPointer(keyPointer?: unknown): boolean {
  return incidentKeyPointerBase(keyPointer) === 'injuryType';
}

export function effectiveIncidentAnswerType(item: any): string {
  if (isIncidentYesNoKeyPointer(item?.keyPointer)) return 'yesNo';
  return item?.tipoRespuesta;
}

export function seedYesNoFromCheckbox(item: any): string | null {
  if (item?.yesNo != null && String(item.yesNo).trim() !== '') {
    return String(item.yesNo);
  }
  if (item?.checkbox === true) return 'Si';
  if (item?.checkbox === false) return 'No';
  return null;
}

export function coerceIncidentYesNoBoolean(value: any): boolean | null {
  if (value === true || value === false) return value;
  if (value == null || value === '') return null;
  const normalized = String(value).trim().toLowerCase();
  if (['si', 'sí', 'yes', 'true', '1'].includes(normalized)) return true;
  if (['no', 'false', '0'].includes(normalized)) return false;
  return null;
}

export function booleanToYesNo(value: any): string | null {
  if (value === true) return 'Si';
  if (value === false) return 'No';
  return null;
}

export function filterCrushFromInjuryAlternativas(alternativas: any, keyPointer?: unknown): any {
  if (!isInjuryTypeKeyPointer(keyPointer) || !Array.isArray(alternativas)) {
    return alternativas;
  }
  return alternativas.filter((alt) => {
    const id = alt?.id ?? alt?.value;
    return String(id) !== 'Crush';
  });
}

export function applyIncidentYesNoBooleanFields(incidentData: Record<string, any> | null | undefined) {
  if (!incidentData) return;
  for (const key of ['propertyDamage', 'atSea']) {
    if (!(key in incidentData) && !(`incident_${key}` in incidentData)) continue;
    const raw = key in incidentData ? incidentData[key] : incidentData[`incident_${key}`];
    const coerced = coerceIncidentYesNoBoolean(raw);
    incidentData[key] = coerced;
  }
}
